<template>
<div class="container-izracun">
    <form class="vue-form" @submit.prevent="calculate">
        <h2 class="naslov-za-izracun">
            KAKO ELEKTRIČNI RENAULT ŠTEDI VAŠ NOVAC?
        </h2>
        <p class="podnaslov">
            ALAT ZA IZRAČUN OPERATIVNIH TROŠKOVA TIJEKOM RAZDOBLJA EKSPLOATACIJE BATERIJSKOG ELEKTRIČNOG VOZILA
        </p>
        <p class="tekst">
            Električni automobili su nam svima vrlo zanimljivi, no kakva je zapravo njihova isplativost, da li je moguće da pored toga što troše manje energije i čuvaju okoliš oni istovremeno nam štede novac? Pođite s nama na ovo zanimljivo putovanje i saznajte brojne prednosti zbog kojih ćete se još više zaljubiti u naše nove električne Renault modele.
        </p>

        <div class="buttonWrap">
            <button class="accordion border-1" type="button" @click="
            (ev) => {
              ev.currentTarget.classList.toggle('active');
            }
          ">
                O čemu se tu zapravo radi?
            </button>
            <div class="panel">
                <p>
                    Alat za izračun operativnih troškova tijekom razdoblja eksploatacije baterijskog električnog vozila (BEV) omogućuje uvid s financijskog stajališta. U alat je komplementaran alatu za izračun energetskih učinaka i učinaka po okoliš tijekom razdoblja eksploatacije baterijskog električnog vozila te kao takav predstavlja stručnu podršku u kupnji i donošenju informiranih odluka.
                </p>
                <p>
                    Svrha predmetnog projekta je formalizirati znanje i iskustvo koje postoji u akademskoj zajednici u oblik koji će omogućiti osmišljavanje i uspostavu inovativnog rješenja. Definiranjem skupa informacija za bazu podataka vozila i referentnih podataka za izračun te osmišljavanjem matematičkog modela kao osnove alata, korisnicima će se pružiti uvid u operativne troškove tijekom faze eksploatacije BEV, odnosno predstavljat će podlogu za razvoj slijednih aplikacija vezanih za područje elektromobilnosti, a u sam alat će biti ugrađeno iskustvo tvrtke Adria P.A. Korištenje alata koji doprinosi informiranoj kupnji će u razdoblju koje slijedi imati sve veći značaj prilikom odluke o nabavci vozila, obzirom da je sve veći udio potrošača koji se koristi suvremenim tehnologijama prilikom procesa odlučivanja, a što je posebno slučaj za veće osobne izdatke kao što je nabavka vozila.
                </p>
            </div>
        </div>
        <fieldset>
            <div>
                <label class="label tooltip" for="em_faktor">
                    Kakav je omjer koji planirate koristiti za punjenje električnog Renaulta?
                    <div class="tooltiptext">
                        Zašto je to bitno? Cijena električne energije koju plaćate na privatnoj i javnim punionicama utječe na isplativost električnog vozila.
                    </div>
                </label>
                <select class="form-control" v-model.number="nacin_pogona" id="em_faktor" required>
                    <option value="1">100% punjenje na privatnoj punionici</option>
                    <option value="0.75">75% punjenje na privatnoj punionici i 25% punjenje na javnoj punionici</option>
                    <option value="0.5">50% punjenje na privatnoj punionici i 50% punjenje na javnoj punionici </option>
                    <option value="0.25">25% punjenje na privatnoj punionici i 75% punjenje na javnoj punionic</option>
                    <option value="0">0% punjenje na privatnoj punionici i 100% punjenje na javnoj punionici </option>
                </select>
            </div>
            <div>
                <label class="label" for="fos_gor">
                    Fosilno gorivo [kn/l]:
                </label>
                <vue-numeric v-bind:min="0" id="fos_gor" class="form-control" v-model="cijena_fosilno_gorivo" currency="HRK" currency-symbol-position="suffix" precision="2" separator="." required></vue-numeric>
            </div>
            <div>
                <label class="label" for="javna_pun">
                    Električna energija za punjenje na privatnoj punionici [kn/kWh]
                </label>
                <vue-numeric v-bind:min="0" id="javna_pun" class="form-control" v-model.number="cijena_javna_pun" currency="HRK" currency-symbol-position="suffix" precision="2" separator="." required></vue-numeric>
            </div>
            <div>
                <label class="label" for="privatna_pun">
                    Električna energija za punjenje na javnoj punionici [kn/kWh]
                </label>
                <vue-numeric v-bind:min="0" id="privatna_pun" class="form-control" v-model.number="cijena_privatna_pun" currency="HRK" currency-symbol-position="suffix" precision="2" separator="." required></vue-numeric>
            </div>
            <div>
                <label class="label tooltip" for="godisnja_km">
                    Koliko prosječno kilometara godišnje vozite?
                    <div class="tooltiptext">
                        Zašto je to bitno? Što više kilometara vozite s novim električnim Renaultom, to više doprinosite zaštiti okoliša.
                    </div>
                </label>
                <select class="form-control" id="godisnja_km" v-model="god_km" required>
                    <option value="10000">10.000</option>
                    <option value="12500">12.500</option>
                    <option value="15000" selected>15.000</option>
                    <option value="17500">17.500</option>
                    <option value="20000">20.000</option>
                </select>
            </div>

            <div>
                <h4>Odaberite svoj novi električni Renault za usporedbu</h4>
                <input class="checkbox-cars form-control" type="radio" name="cars" id="car-1" v-model="odabir_auta" value="Clio" required />
                <label class="for-checkbox-cars" for="car-1">
                    <img src="../assets/novi-clio.jpg" alt="Osobni automobil Clio" class="image-checkhox-cars" />
                    Zoe/Clio
                </label>
                <input class="checkbox-cars" type="radio" name="cars" id="car-2" v-model="odabir_auta" value="Twingo" required />
                <label class="for-checkbox-cars" for="car-2">
                    <img src="../assets/renault-twingo.jpg" alt="Osobni automobil Twingo" class="image-checkhox-cars" />
                    Twingo Z.E./Twingo
                </label>
                <input class="checkbox-cars form-control" type="radio" name="cars" id="car-3" v-model="odabir_auta" value="Captur" required />
                <label class="for-checkbox-cars" for="car-3">
                    <img src="../assets/captur.png" alt="Osobni automobil Captur" class="image-checkhox-cars" />
                    Captur/Captur E-Tech
                </label>
                <input class="checkbox-cars" type="radio" name="cars" id="car-4" v-model="odabir_auta" value="Megane" required />
                <label class="for-checkbox-cars" for="car-4">
                    <img src="../assets/megane.png" alt="Osobni automobil Megane" class="image-checkhox-cars" />
                    Megane/Megane E-Tech
                </label>
            </div>
            <div>
                <h4>Unesite cijene novih vozila: </h4>
                <div>
                    <label class="label" for="konvencionalno">
                        Cijena konvencionalnog automobila
                    </label>
                    <vue-numeric v-bind:min="0" id="konvencionalno" class="form-control" v-model.number="cijena_auto_konv" currency="HRK" currency-symbol-position="suffix" precision="2" separator="." required></vue-numeric>
                </div>
                <div>
                    <label class="label" for="električno">
                        Cijena električnog automobila
                    </label>
                    <vue-numeric v-bind:min="0" id="električno" class="form-control" v-model.number="cijena_auto_el" currency="HRK" currency-symbol-position="suffix" precision="2" separator="." required></vue-numeric>
                </div>
                <div>
                    <label class="label" for="subvencija">
                        Subvencija za električni automobil
                    </label>
                    <vue-numeric v-bind:min="0"  id="subvencija" class="form-control" v-model.number="subvencija" currency="HRK" currency-symbol-position="suffix" precision="2" separator="." required></vue-numeric>
                </div>
            </div>
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Prosječna potrošnja goriva [l/100km]</th>
                        <th colspan="2">Prosječna potrošnja električne energije [kWh/100km]</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Clio</strong></td>
                        <td><strong>Twingo</strong></td>
                        <td><strong>Zoe</strong></td>
                        <td><strong>Twingo Z.E.</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{auti[1].prosj_pot_en}}
                        </td>
                        <td>
                            {{auti[3].prosj_pot_en}}
                        </td>
                        <td>
                            {{auti[0].prosj_pot_en}}
                        </td>
                        <td>
                            {{auti[2].prosj_pot_en}}
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Captur</strong></td>
                        <td><strong>Megane</strong></td>
                        <td><strong>Captur E-Tech</strong></td>
                        <td><strong>Megane E-Tech</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{auti[5].prosj_pot_en}}
                        </td>
                        <td>
                            {{auti[7].prosj_pot_en}}
                        </td>
                        <td>
                            {{auti[4].prosj_pot_en2}}
                        </td>
                        <td>
                            {{auti[6].prosj_pot_en2}}
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="padding">
                <input type="submit" value="Krenimo na putovanje s Vašim novim električnim Renaultom!" />
            </div>
        </fieldset>
    </form>

    <div class="rezultat" v-if="doneCalculate && odabir_auta == 'Clio'">
        <div class="padding"></div>
        <h2 class="naslov-za-izracun">Ušteda</h2>
        <p class="smallerText">
            Električni automobil ima manje godišnje troškova za pogonski energent, u vašem slučaju čak
            {{Math.round(((god_tro_pog_clio - god_tro_pog_zoe)/god_tro_pog_clio)*100)}}% manje, odnosno {{new Intl.NumberFormat("de-DE").format(god_tro_pog_clio - god_tro_pog_zoe)}} kn u odnosu na model s klasičnim motorom.
        </p>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Godišnji troškovi za pogonski energent</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Clio</strong></td>
                        <td><strong>Zoe</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_tro_pog_clio)}} (l/god)
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_tro_pog_zoe)}} (kWh/god)
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding"></div>
        <div class="padding">
            <h2 class="naslov-za-izracun">Isplativost vozila po godinama</h2>
            <div class="padding"></div>
            <canvas id="lineZoeClio"></canvas>
        </div>
        <div class="padding"></div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th>Godina</th>
                        <th>Clio</th>
                        <th>Zoe</th>
                        <th>Km prijeđeno</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="n in 15" :key="n">
                        <td>{{ n }}</td>
                        <td>{{ new Intl.NumberFormat("de-DE").format(ukupni_troskovi_clio[n-1]) }} kn</td>
                        <td>{{ new Intl.NumberFormat("de-DE").format( ukupni_troskovi_zoe[n-1]) }} kn</td>
                        <td>{{ new Intl.NumberFormat("de-DE").format(n * god_km) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding"></div>
        <div class="padding">
            <h2 class="naslov-za-izracun">Točka pokrića kupovine električnog vozila</h2>
            <div class="padding"></div>
            <canvas id="lineExpenses"></canvas>
        </div>
        <div class="bottomText">
            <h3>
                Jeste li se već odlučili za kupnju novog električnog Renaulta?
            </h3>
            <p><a href="https://www.fzoeu.hr/hr/energetska_ucinkovitost/poticanje_energetske_ucinkovitosti_u_prometu/sufinanciranje_nabave_energetski_ucinkovitijih_vozila/" target="_blank">
                    Jeste li znali da pritom možete dobiti izdašnu subvenciju Fonda za zaštitu okoliša i energetsku učinkovitost?</a> </p>
            Kako biste se informirali i osobno doživjeli sve prednosti električnih vozila dobrodošli ste u naš prodajni centar na adresi Mihačeva draga 7 u Rijeci.
            Javite nam se za dogovor na <a href="tel:+38551226620">+385 51 226 620</a>, tu smo za Vas.
        </div>
    </div>

    <div class="rezultat" v-if="doneCalculate && odabir_auta == 'Twingo'">
        <div class="padding"></div>
        <h2 class="naslov-za-izracun">Ušteda</h2>
        <p class="smallerText">
            Električni automobil ima manje godišnje troškova za pogonski energent, u vašem slučaju čak
            {{Math.round(((god_tro_pog_twingo - god_tro_pog_twingo_ze)/god_tro_pog_twingo)*100)}}% manje, odnosno {{new Intl.NumberFormat("de-DE").format(god_tro_pog_twingo - god_tro_pog_twingo_ze)}} kn u odnosu na model s klasičnim motorom.
        </p>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Godišnji troškovi za pogonski energent</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Twingo</strong></td>
                        <td><strong>Twingo Z.E.</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_tro_pog_twingo)}} (l/god)
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_tro_pog_twingo_ze)}} (kWh/god)
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding"></div>
        <div class="padding">
            <h2 class="naslov-za-izracun">Isplativost vozila po godinama</h2>
            <div class="padding"></div>
            <canvas id="lineTwingo"></canvas>
        </div>
        <div class="padding"></div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th>Godina</th>
                        <th>Twingo</th>
                        <th>Twingo Z.E.</th>
                        <th>Km prijeđeno</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="n in 15" :key="n">
                        <td>{{ n }}</td>
                        <td>{{ new Intl.NumberFormat("de-DE").format(ukupni_troskovi_twingo[n-1]) }} kn</td>
                        <td>{{ new Intl.NumberFormat("de-DE").format( ukupni_troskovi_twingo_ze[n-1]) }} kn</td>
                        <td>{{ new Intl.NumberFormat("de-DE").format(n * god_km) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding"></div>
        <div class="padding">
            <h2 class="naslov-za-izracun">Točka pokrića kupovine električnog vozila</h2>
            <div class="padding"></div>
            <canvas id="lineExpenses"></canvas>
        </div>
        <div class="bottomText">
            <h3>
                Jeste li se već odlučili za kupnju novog električnog Renaulta?
            </h3>
            <p><a href="https://www.fzoeu.hr/hr/energetska_ucinkovitost/poticanje_energetske_ucinkovitosti_u_prometu/sufinanciranje_nabave_energetski_ucinkovitijih_vozila/" target="_blank">
                    Jeste li znali da pritom možete dobiti izdašnu subvenciju Fonda za zaštitu okoliša i energetsku učinkovitost?</a> </p>
            Kako biste se informirali i osobno doživjeli sve prednosti električnih vozila dobrodošli ste u naš prodajni centar na adresi Mihačeva draga 7 u Rijeci.
            Javite nam se za dogovor na <a href="tel:+38551226620">+385 51 226 620</a>, tu smo za Vas.
        </div>
    </div>

    <div class="rezultat" v-if="doneCalculate && odabir_auta == 'Captur'">
        <div class="padding"></div>
        <h2 class="naslov-za-izracun">Ušteda</h2>
        <p class="smallerText">
            Električni automobil ima manje godišnje troškova za pogonski energent, u vašem slučaju čak
            {{Math.round(((god_tro_pog_captur - god_tro_pog_captur_tech)/god_tro_pog_captur)*100)}}% manje, odnosno {{new Intl.NumberFormat("de-DE").format(god_tro_pog_captur - god_tro_pog_captur_tech)}} kn u odnosu na model s klasičnim motorom.
        </p>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Godišnji troškovi za pogonski energent</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Captur</strong></td>
                        <td><strong>Captur Tech</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_tro_pog_captur)}} (l/god)
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_tro_pog_captur_tech)}} (kWh/god)
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding"></div>
        <div class="padding">
            <h2 class="naslov-za-izracun">Isplativost vozila po godinama</h2>
            <div class="padding"></div>
            <canvas id="lineCaptur"></canvas>
        </div>
        <div class="padding"></div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th>Godina</th>
                        <th>Captur</th>
                        <th>Captur Tech</th>
                        <th>Km prijeđeno</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="n in 15" :key="n">
                        <td>{{ n }}</td>
                        <td>{{ new Intl.NumberFormat("de-DE").format(ukupni_troskovi_captur[n-1]) }} kn</td>
                        <td>{{ new Intl.NumberFormat("de-DE").format( ukupni_troskovi_captur_tech[n-1]) }} kn</td>
                        <td>{{ new Intl.NumberFormat("de-DE").format(n * god_km) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding"></div>
        <div class="padding">
            <h2 class="naslov-za-izracun">Točka pokrića kupovine električnog vozila</h2>
            <div class="padding"></div>
            <canvas id="lineExpenses"></canvas>
        </div>
        <div class="bottomText">
            <h3>
                Jeste li se već odlučili za kupnju novog električnog Renaulta?
            </h3>
            <p><a href="https://www.fzoeu.hr/hr/energetska_ucinkovitost/poticanje_energetske_ucinkovitosti_u_prometu/sufinanciranje_nabave_energetski_ucinkovitijih_vozila/" target="_blank">
                    Jeste li znali da pritom možete dobiti izdašnu subvenciju Fonda za zaštitu okoliša i energetsku učinkovitost?</a> </p>
            Kako biste se informirali i osobno doživjeli sve prednosti električnih vozila dobrodošli ste u naš prodajni centar na adresi Mihačeva draga 7 u Rijeci.
            Javite nam se za dogovor na <a href="tel:+38551226620">+385 51 226 620</a>, tu smo za Vas.
        </div>
    </div>

    <div class="rezultat" v-if="doneCalculate && odabir_auta == 'Megane'">
        <div class="padding"></div>
        <h2 class="naslov-za-izracun">Ušteda</h2>
        <p class="smallerText">
            Električni automobil ima manje godišnje troškova za pogonski energent, u vašem slučaju čak
            {{Math.round(((god_tro_pog_megane - god_tro_pog_megane_tech)/god_tro_pog_megane) * 100) }}% manje, odnosno {{ new Intl.NumberFormat("de-DE").format(god_tro_pog_megane - god_tro_pog_megane_tech)}} kn u odnosu na model s klasičnim motorom.
        </p>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Godišnji troškovi za pogonski energent</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Megane</strong></td>
                        <td><strong>Megane Tech</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_tro_pog_megane)}} (l/god)
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_tro_pog_megane_tech)}} (kWh/god)
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding"></div>
        <div class="padding">
            <h2 class="naslov-za-izracun">Isplativost vozila po godinama</h2>
            <div class="padding"></div>
            <canvas id="lineMegane"></canvas>
        </div>
        <div class="padding"></div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th>Godina</th>
                        <th>Megane</th>
                        <th>Megane Tech</th>
                        <th>Km prijeđeno</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="n in 15" :key="n">
                        <td>{{ n }}</td>
                        <td>{{ new Intl.NumberFormat("de-DE").format(ukupni_troskovi_megane[n-1]) }} kn</td>
                        <td>{{ new Intl.NumberFormat("de-DE").format( ukupni_troskovi_megane_tech[n-1]) }} kn</td>
                        <td>{{ new Intl.NumberFormat("de-DE").format(n * god_km) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding"></div>
        <div class="padding">
            <h2 class="naslov-za-izracun">Točka pokrića kupovine električnog vozila</h2>
            <div class="padding"></div>
            <canvas id="lineExpenses"></canvas>
        </div>
        <div class="bottomText">
            <h3>
                Jeste li se već odlučili za kupnju novog električnog Renaulta?
            </h3>
            <p><a href="https://www.fzoeu.hr/hr/energetska_ucinkovitost/poticanje_energetske_ucinkovitosti_u_prometu/sufinanciranje_nabave_energetski_ucinkovitijih_vozila/" target="_blank">
                    Jeste li znali da pritom možete dobiti izdašnu subvenciju Fonda za zaštitu okoliša i energetsku učinkovitost?</a> </p>
            Kako biste se informirali i osobno doživjeli sve prednosti električnih vozila dobrodošli ste u naš prodajni centar na adresi Mihačeva draga 7 u Rijeci.
            Javite nam se za dogovor na <a href="tel:+38551226620">+385 51 226 620</a>, tu smo za Vas.
        </div>
    </div>
</div>
</template>

<script>
import Vue from "vue";
import Chart from 'chart.js';
import VueNumeric from 'vue-numeric';
export default {
    data() {
        return {
            auti: [{
                    id: 1,
                    name: "Zoe LIFE R110",
                    prosj_pot_en: 172,
                    prosj_CO2_emisija: 0.3,
                    kapacitet_bat: 52,
                    cijena_novog_voz: 220900,
                    subvencija: 70000,
                    ukupno_cijena: 150900,
                    teh_i_reg: 1000,
                    osiguranje: 1100,
                    god_odrz: 400,
                },
                {
                    id: 2,
                    name: "Novi Clio LIFE SCe 75",
                    prosj_pot_en: 5,
                    prosj_CO2_emisija: 111,
                    cijena_novog_voz: 98400,
                    ukupno_cijena: 98400,
                    teh_i_reg: 1000,
                    osiguranje: 1100,
                    god_odrz: 900,
                },
                {
                    id: 3,
                    name: "Twingo Z.E.",
                    prosj_pot_en: 163,
                    prosj_CO2_emisija: 0.3,
                    kapacitet_bat: 21.3,
                    cijena_novog_voz: 145050,
                    subvencija: 70000,
                    ukupno_cijena: 75050,
                    teh_i_reg: 1000,
                    osiguranje: 1100,
                    god_odrz: 400,
                },
                {
                    id: 4,
                    name: "Twingo",
                    prosj_pot_en: 4.5,
                    prosj_CO2_emisija: 99,
                    cijena_novog_voz: 74610,
                    ukupno_cijena: 74610,
                    teh_i_reg: 1000,
                    osiguranje: 1100,
                    god_odrz: 900,
                },
                {
                    id: 5,
                    name: "Captur E-Tech",
                    prosj_pot_en1: 1.5,
                    prosj_pot_en2: 19.4,
                    prosj_CO2_emisija: 34,
                    cijena_novog_voz: 227400,
                    subvencija: 70000,
                    ukupno_cijena: 157400,
                    teh_i_reg: 1000,
                    osiguranje: 1100,
                    god_odrz: 1750,
                },
                {
                    id: 6,
                    name: "Captur",
                    prosj_pot_en: 5.8,
                    prosj_CO2_emisija: 130,
                    cijena_novog_voz: 121200,
                    ukupno_cijena: 121200,
                    teh_i_reg: 1000,
                    osiguranje: 1100,
                    god_odrz: 1765,
                },
                {
                    id: 7,
                    name: "Megane E-Tech",
                    prosj_pot_en1: 1.6,
                    prosj_pot_en2: 18.1,
                    prosj_CO2_emisija: 29,
                    kapacitet_bat: null,
                    cijena_novog_voz: 241000,
                    subvencija: 70000,
                    ukupno_cijena: 171000,
                    teh_i_reg: 1000,
                    osiguranje: 1100,
                    god_odrz: 1765,
                },
                {
                    id: 8,
                    name: "Megane",
                    prosj_pot_en: 5.9,
                    prosj_CO2_emisija: 134,
                    cijena_novog_voz: 143000,
                    ukupno_cijena: 143000,
                    teh_i_reg: 1000,
                    osiguranje: 1100,
                    god_odrz: 1750,
                },
            ],

            cijena_fosilno_gorivo: 9.02,
            cijena_javna_pun: 2.5,
            cijena_privatna_pun: 0.8,
            god_km: 15000,
            nacin_pogona: 1,
            cijena_el_en: null,
            odabir_auta: null,

            subvencija: 70000,
            cijena_auto_konv: null,
            cijena_auto_el: null,

            doneCalculate: false,

            god_tro_pog_clio_help: null,
            god_tro_pog_zoe_help: null,
            god_tro_pog_twingo_ze_help: null,
            god_tro_pog_twingo_help: null,
            god_tro_pog_captur_help: null,
            god_tro_pog_captur_tech_help: null,
            god_tro_pog_megane_help: null,
            god_tro_pog_megane_tech_help: null,

            god_tro_pog_clio: null,
            god_tro_pog_zoe: null,
            god_tro_pog_twingo_ze: null,
            god_tro_pog_twingo: null,
            god_tro_pog_captur: null,
            god_tro_pog_captur_tech: null,
            god_tro_pog_megane: null,
            god_tro_pog_megane_tech: null,

            ukupni_troskovi_zoe: [],
            ukupni_troskovi_clio: [],
            ukupni_troskovi_twingo_ze: [],
            ukupni_troskovi_twingo: [],
            ukupni_troskovi_captur: [],
            ukupni_troskovi_captur_tech: [],
            ukupni_troskovi_megane: [],
            ukupni_troskovi_megane_tech: [],

            cijena_voz_po_god: [],
            fiksni_trosak_el: [],
            ukupni_trosak_el: [],

            ukupni_prihod_el: [],
            ukupni_prihod_kon: [],
            ukupni_prihod_ke: [],

        };
    },
    methods: {
        calculate() {
            if (this.nacin_pogona === 1) {
                this.cijena_el_en = this.cijena_privatna_pun;
            } else if (this.nacin_pogona === 0) {
                this.cijena_el_en = this.cijena_javna_pun;
            } else if (this.nacin_pogona === 0.75) {
                this.cijena_el_en = 0.25 * this.cijena_javna_pun + 0.75 * this.cijena_privatna_pun;
            } else if (this.nacin_pogona === 0.50) {
                this.cijena_el_en = 0.5 * this.cijena_javna_pun + 0.5 * this.cijena_privatna_pun;
            } else if (this.nacin_pogona === 0.25) {
                this.cijena_el_en = 0.75 * this.cijena_javna_pun + 0.25 * this.cijena_privatna_pun;
            }

            this.god_tro_pog_clio_help = (this.god_km / 100) * this.auti[1].prosj_pot_en;
            this.god_tro_pog_zoe_help = ((this.god_km / 100) * this.auti[0].prosj_pot_en) / 10;
            this.god_tro_pog_twingo_ze_help = ((this.god_km / 100) * this.auti[2].prosj_pot_en) / 10;
            this.god_tro_pog_twingo_help = (this.god_km / 100) * this.auti[3].prosj_pot_en;

            this.god_tro_pog_captur_help = (this.god_km / 100) * this.auti[5].prosj_pot_en;
            this.god_tro_pog_captur_tech_help = ((this.god_km / 100) * this.auti[4].prosj_pot_en2) / 10;
            this.god_tro_pog_megane_help = (this.god_km / 100) * this.auti[7].prosj_pot_en;
            this.god_tro_pog_megane_tech_help = ((this.god_km / 100) * this.auti[6].prosj_pot_en2) / 10;

            this.god_tro_pog_clio = this.god_tro_pog_clio_help * this.cijena_fosilno_gorivo;
            this.god_tro_pog_zoe = this.god_tro_pog_zoe_help * this.cijena_el_en;
            this.god_tro_pog_twingo_ze = this.god_tro_pog_twingo_ze_help * this.cijena_el_en
            this.god_tro_pog_twingo = this.god_tro_pog_twingo_help * this.cijena_fosilno_gorivo

            this.god_tro_pog_captur = this.god_tro_pog_captur_help * this.cijena_fosilno_gorivo
            this.god_tro_pog_captur_tech = this.god_tro_pog_captur_tech_help * this.cijena_el_en
            this.god_tro_pog_megane = this.god_tro_pog_megane_help * this.cijena_fosilno_gorivo
            this.god_tro_pog_megane_tech = this.god_tro_pog_megane_tech_help * this.cijena_el_en

            this.calculateUkupniTroskovi();
            this.calculateTockaPokrica();

            this.doneCalculate = !this.doneCalculate;
            Vue.nextTick(() => {
                if (this.odabir_auta === "Clio") {
                    this.createChart1();
                } else if (this.odabir_auta === "Twingo") {
                    this.createChart2();
                } else if (this.odabir_auta === "Captur") {
                    this.createChart3();
                } else if (this.odabir_auta === "Megane") {
                    this.createChart4();
                }
                this.createChartExpenses();
                this.scrollToElement();
            });
        },

        calculateUkupniTroskovi() {
            for (let i = 0; i < 15; i++) {
                if (i === 0) {
                    this.ukupni_troskovi_zoe[i] = this.cijena_auto_el - this.subvencija + this.auti[0].teh_i_reg +
                        this.auti[0].osiguranje + this.auti[0].god_odrz + this.god_tro_pog_zoe;
                    this.ukupni_troskovi_clio[i] = this.cijena_auto_konv + this.auti[1].teh_i_reg +
                        this.auti[1].osiguranje + this.auti[1].god_odrz + this.god_tro_pog_clio;

                    this.ukupni_troskovi_twingo_ze[i] = this.cijena_auto_el - this.subvencija + this.auti[2].teh_i_reg +
                        this.auti[2].osiguranje + this.auti[2].god_odrz + this.god_tro_pog_twingo_ze;
                    this.ukupni_troskovi_twingo[i] = this.cijena_auto_konv + this.auti[3].teh_i_reg +
                        this.auti[3].osiguranje + this.auti[3].god_odrz + this.god_tro_pog_twingo;

                    this.ukupni_troskovi_captur_tech[i] = this.cijena_auto_el - this.subvencija + this.auti[4].teh_i_reg +
                        this.auti[4].osiguranje + this.auti[4].god_odrz + this.god_tro_pog_captur_tech;
                    this.ukupni_troskovi_captur[i] = this.cijena_auto_konv + this.auti[5].teh_i_reg +
                        this.auti[5].osiguranje + this.auti[5].god_odrz + this.god_tro_pog_captur;

                    this.ukupni_troskovi_megane_tech[i] = this.cijena_auto_el - this.subvencija + this.auti[6].teh_i_reg +
                        this.auti[6].osiguranje + this.auti[6].god_odrz + this.god_tro_pog_megane_tech;
                    this.ukupni_troskovi_megane[i] = this.cijena_auto_konv + this.auti[7].teh_i_reg +
                        this.auti[7].osiguranje + this.auti[7].god_odrz + this.god_tro_pog_megane;
                } else {
                    this.ukupni_troskovi_zoe[i] = this.ukupni_troskovi_zoe[i - 1] + this.auti[0].teh_i_reg +
                        this.auti[0].osiguranje + this.auti[0].god_odrz + this.god_tro_pog_zoe;
                    this.ukupni_troskovi_clio[i] = this.ukupni_troskovi_clio[i - 1] + this.auti[1].teh_i_reg +
                        this.auti[1].osiguranje + this.auti[1].god_odrz + this.god_tro_pog_clio;

                    this.ukupni_troskovi_twingo_ze[i] = this.ukupni_troskovi_twingo_ze[i - 1] + this.auti[2].teh_i_reg +
                        this.auti[2].osiguranje + this.auti[2].god_odrz + this.god_tro_pog_twingo_ze;
                    this.ukupni_troskovi_twingo[i] = this.ukupni_troskovi_twingo[i - 1] + this.auti[3].teh_i_reg +
                        this.auti[3].osiguranje + this.auti[3].god_odrz + this.god_tro_pog_twingo;

                    this.ukupni_troskovi_captur_tech[i] = this.ukupni_troskovi_captur_tech[i - 1] + this.auti[4].teh_i_reg +
                        this.auti[4].osiguranje + this.auti[4].god_odrz + this.god_tro_pog_captur_tech;
                    this.ukupni_troskovi_captur[i] = this.ukupni_troskovi_captur[i - 1] + this.auti[5].teh_i_reg +
                        this.auti[5].osiguranje + this.auti[5].god_odrz + this.god_tro_pog_captur;

                    this.ukupni_troskovi_megane_tech[i] = this.ukupni_troskovi_megane_tech[i - 1] + this.auti[6].teh_i_reg +
                        this.auti[6].osiguranje + this.auti[6].god_odrz + this.god_tro_pog_megane_tech;
                    this.ukupni_troskovi_megane[i] = this.ukupni_troskovi_megane[i - 1] + this.auti[7].teh_i_reg +
                        this.auti[7].osiguranje + this.auti[7].god_odrz + this.god_tro_pog_megane;
                }
            }
        },

        calculateTockaPokrica() {
            if (this.odabir_auta === "Clio") {
                for (let i = 0; i < 15; i++) {
                    if (i === 0) {
                        this.ukupni_prihod_el[i] = this.god_tro_pog_zoe;
                        this.ukupni_prihod_kon[i] = this.god_tro_pog_clio;

                        this.cijena_voz_po_god[i] = this.auti[0].ukupno_cijena / 15;
                    } else {
                        this.ukupni_prihod_el[i] = this.god_tro_pog_zoe + this.ukupni_prihod_el[i - 1];
                        this.ukupni_prihod_kon[i] = this.god_tro_pog_clio + this.ukupni_prihod_kon[i - 1];

                        this.cijena_voz_po_god[i] = this.cijena_voz_po_god[0] * (i + 1);
                    }
                    this.ukupni_prihod_ke[i] = this.ukupni_prihod_kon[i] - this.ukupni_prihod_el[i];
                    this.fiksni_trosak_el[i] = this.cijena_voz_po_god[0] + this.auti[0].teh_i_reg + this.auti[0].osiguranje + this.auti[0].god_odrz;
                }
            } else if (this.odabir_auta === "Twingo") {
                for (let i = 0; i < 15; i++) {
                    if (i === 0) {
                        this.ukupni_prihod_el[i] = this.god_tro_pog_twingo_ze;
                        this.ukupni_prihod_kon[i] = this.god_tro_pog_twingo;

                        this.cijena_voz_po_god[i] = this.auti[2].ukupno_cijena / 15;
                    } else {
                        this.ukupni_prihod_el[i] = this.god_tro_pog_twingo_ze + this.ukupni_prihod_el[i - 1];
                        this.ukupni_prihod_kon[i] = this.god_tro_pog_twingo + this.ukupni_prihod_kon[i - 1];

                        this.cijena_voz_po_god[i] = this.cijena_voz_po_god[2] * (i + 1);
                    }
                    this.ukupni_prihod_ke[i] = this.ukupni_prihod_kon[i] - this.ukupni_prihod_el[i];
                    this.fiksni_trosak_el[i] = this.cijena_voz_po_god[0] + this.auti[2].teh_i_reg + this.auti[2].osiguranje + this.auti[2].god_odrz;
                }
            } else if (this.odabir_auta === "Captur") {
                for (let i = 0; i < 15; i++) {
                    if (i === 0) {
                        this.ukupni_prihod_el[i] = this.god_tro_pog_captur_tech;
                        this.ukupni_prihod_kon[i] = this.god_tro_pog_captur;

                        this.cijena_voz_po_god[i] = this.auti[4].ukupno_cijena / 15;
                    } else {
                        this.ukupni_prihod_el[i] = this.god_tro_pog_captur_tech + this.ukupni_prihod_el[i - 1];
                        this.ukupni_prihod_kon[i] = this.god_tro_pog_captur + this.ukupni_prihod_kon[i - 1];

                        this.cijena_voz_po_god[i] = this.cijena_voz_po_god[4] * (i + 1);
                    }
                    this.ukupni_prihod_ke[i] = this.ukupni_prihod_kon[i] - this.ukupni_prihod_el[i];
                    this.fiksni_trosak_el[i] = this.cijena_voz_po_god[0] + this.auti[4].teh_i_reg + this.auti[4].osiguranje + this.auti[4].god_odrz;
                }
            } else if (this.odabir_auta === "Megane") {
                for (let i = 0; i < 15; i++) {
                    if (i === 0) {
                        this.ukupni_prihod_el[i] = this.god_tro_pog_megane_tech;
                        this.ukupni_prihod_kon[i] = this.god_tro_pog_megane;

                        this.cijena_voz_po_god[i] = this.auti[6].ukupno_cijena / 15;
                    } else {
                        this.ukupni_prihod_el[i] = this.god_tro_pog_megane_tech + this.ukupni_prihod_el[i - 1];
                        this.ukupni_prihod_kon[i] = this.god_tro_pog_megane + this.ukupni_prihod_kon[i - 1];

                        this.cijena_voz_po_god[i] = this.cijena_voz_po_god[6] * (i + 1);
                    }
                    this.ukupni_prihod_ke[i] = this.ukupni_prihod_kon[i] - this.ukupni_prihod_el[i];
                    this.fiksni_trosak_el[i] = this.cijena_voz_po_god[0] + this.auti[6].teh_i_reg + this.auti[6].osiguranje + this.auti[6].god_odrz;
                }
            }

            for (let i = 0; i < 15; i++) {
                if (i === 0) {
                    //this.ukupni_trosak_el[i] = this.fiksni_trosak_el + this.ukupni_prihod_el[i];
                    this.ukupni_trosak_el[i] = this.fiksni_trosak_el[i];
                } else {
                    this.ukupni_trosak_el[i] = this.fiksni_trosak_el[i] + this.ukupni_trosak_el[i - 1];
                }
            }
        },

        setLegend(html) {
            this.message = html
        },

        createChartExpenses() {
            var lineExpenses = this.$el.querySelector('#lineExpenses').getContext('2d');
            lineExpenses.canvas.width  = 800;
            lineExpenses.canvas.height = 600;
            new Chart(lineExpenses, {
                type: 'line',
                data: {
                    labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
                    datasets: [{
                            label: 'Fiksni troškovi električno vozilo',
                            data: this.fiksni_trosak_el,
                            borderColor: ['#720000'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        },
                        {
                            label: 'Ukupni troškovi električno vozilo',
                            data: this.ukupni_trosak_el,
                            borderColor: ['#00b300'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        },
                        {
                            label: 'Prihod električno-konvencionalno vozilo',
                            data: this.ukupni_prihod_ke,
                            borderColor: ['#00bfff'],
                            backgroundColor: 'transparent',
                            borderWidth: 2,
                        }
                    ]
                },

                options: {
                    maintainAspectRatio: true,
                    legend: {
                        display: true,
                        position: 'bottom',
                        fullWidth: true,
                        labels: {
                            fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                        },
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Trošak[kn]',
                                fontSize: 18,
                            },
                        }],
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Godine',
                                fontSize: 18,
                            },
                        }],
                    }
                },
            });
        },

        createChart1() {
            var lineZoeClio = this.$el.querySelector('#lineZoeClio').getContext('2d');
            lineZoeClio.canvas.width  = 800;
            lineZoeClio.canvas.height = 600;
            new Chart(lineZoeClio, {
                type: 'line',
                data: {
                    labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
                    datasets: [{
                            label: 'Zoe',
                            data: this.ukupni_troskovi_zoe,
                            borderColor: ['#00b300'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        },
                        {
                            label: 'Clio',
                            data: this.ukupni_troskovi_clio,
                            borderColor: ['#00bfff'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        }
                    ]
                },
                options: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        fullWidth: true,
                        labels: {
                            fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                        },
                    },
                    maintainAspectRatio: true,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Godišnji troškovi [kn]',
                                fontSize: 18,
                            },
                        }],
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Godine',
                                fontSize: 18,
                            },
                        }],
                    }
                }
            });
        },

        createChart2() {
            var lineTwingo = this.$el.querySelector('#lineTwingo').getContext('2d');
            lineTwingo.canvas.width  = 800;
            lineTwingo.canvas.height = 600;
            new Chart(lineTwingo, {
                type: 'line',
                data: {
                    labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
                    datasets: [{
                            label: 'Twingo Z.E.',
                            data: this.ukupni_troskovi_twingo_ze,
                            borderColor: ['#720000'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        },
                        {
                            label: 'Twingo',
                            data: this.ukupni_troskovi_twingo,
                            borderColor: ['#e69500'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        }
                    ]
                },
                options: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        fullWidth: true,
                        labels: {
                            fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                        },
                    },
                    maintainAspectRatio: true,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Godišnji troškovi [kn]',
                                fontSize: 18,
                            },
                        }],
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Godine',
                                fontSize: 18,
                            },
                        }],
                    }
                }
            });
        },

        createChart3() {
            var lineCaptur = this.$el.querySelector('#lineCaptur').getContext('2d');
            lineCaptur.canvas.width  = 800;
            lineCaptur.canvas.height = 600;
            new Chart(lineCaptur, {
                type: 'line',
                data: {
                    labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
                    datasets: [{
                            label: 'Captur Tech',
                            data: this.ukupni_troskovi_captur_tech,
                            borderColor: ['#00b300'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        },
                        {
                            label: 'Captur',
                            data: this.ukupni_troskovi_captur,
                            borderColor: ['#00bfff'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        }
                    ]
                },
                options: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        fullWidth: true,
                        labels: {
                            fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                        },
                    },
                    maintainAspectRatio: true,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Godišnji troškovi [kn]',
                                fontSize: 18,
                            },
                        }],
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Godine',
                                fontSize: 18,
                            },
                        }],
                    }
                }
            });
        },

        createChart4() {
            var lineMegane = this.$el.querySelector('#lineMegane').getContext('2d');
            lineMegane.canvas.width  = 800;
            lineMegane.canvas.height = 600;
            new Chart(lineMegane, {
                type: 'line',
                data: {
                    labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
                    datasets: [{
                            label: 'Megane Tech',
                            data: this.ukupni_troskovi_megane_tech,
                            borderColor: ['#720000'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        },
                        {
                            label: 'Megane',
                            data: this.ukupni_troskovi_megane,
                            borderColor: ['#e69500'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        }
                    ]
                },
                options: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        fullWidth: true,
                        labels: {
                            fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                        },
                    },
                    maintainAspectRatio: true,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Godišnji troškovi [kn]',
                                fontSize: 18,
                            },
                        }],
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Godine',
                                fontSize: 18,
                            },
                        }],
                    }
                }
            });
        },

        scrollToElement() {
            const el = this.$el.getElementsByClassName("rezultat")[0];

            if (el) {
                el.scrollIntoView();
            }
        },
    },
    watch: {
        odabir_auta() {
            if (this.odabir_auta === "Clio") {
                this.cijena_auto_konv = this.auti[1].cijena_novog_voz;
                this.cijena_auto_el = this.auti[0].cijena_novog_voz;
            } else if (this.odabir_auta === "Twingo") {
                this.cijena_auto_konv = this.auti[3].cijena_novog_voz;
                this.cijena_auto_el = this.auti[2].cijena_novog_voz;
            } else if (this.odabir_auta === "Captur") {
                this.cijena_auto_konv = this.auti[5].cijena_novog_voz;
                this.cijena_auto_el = this.auti[4].cijena_novog_voz;
            } else if (this.odabir_auta === "Megane") {
                this.cijena_auto_konv = this.auti[7].cijena_novog_voz;
                this.cijena_auto_el = this.auti[6].cijena_novog_voz;
            }

            if (this.doneCalculate === true) {
                this.doneCalculate = !this.doneCalculate;
            }
        }
    },
    components: {
        VueNumeric
    }
};
</script>

<style scoped>
@import "../css/main.css";
</style>
